import { useState } from 'react';
import {
  List,
  Datagrid,
  ListProps,
  TextField,
  useUpdate,
  useNotify,
  TextInput,
  useRecordContext
} from 'react-admin';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Answer } from '../domain.js';
import { DefaultPagination } from '../components/pagination.js';

export const RedactAnswerIcon = RemoveCircleIcon;

const postFilters = [
  <TextInput label="Question" source="question_id" alwaysOn />,
];

export const RedactList: React.FC<ListProps> = (props) => (
  <List
    {...props}
    filters={postFilters}
    perPage={100}
    pagination={<DefaultPagination />}
    exporter={false}
    sort={{ field: 'created_at', order: 'DESC' }}
  >
    <Datagrid>
      <TextField source="question_id" />
      <RedactBlock />
      <TagsBlock />
      <TextField source="redacted_at" />
    </Datagrid>
  </List>
);

const RedactBlock: React.FC = () => {
  const record = useRecordContext<Answer>();
  if (!record) return null;

  const notify = useNotify();
  const [update] = useUpdate();
  
  // Initialize the checkedTranscript and handle changes
  const [redactedTranscript, setRedactedTranscript] = useState(record.redacted_transcript ?? record.transcript);
 
  const handleTranscriptChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setRedactedTranscript(e.target.value);
  };
  
  // Set save button label
  var saveLabel = "Update";
  if (record.redacted_transcript == null) saveLabel = "Save"; 
 
  // Handle save button
  const handleSave = () => {
    update(
      'redact',
      { 
        id: record.id,
        data: {
          redacted_transcript: redactedTranscript,
          redacted_at: 'now',
        },
        previousData: record,
      },
      {
        onSuccess: () => notify('Transcript updated', { type: 'info' }),
        onError: (error) => {
          console.error('Update error details:', error);
          notify('Error updating transcript', { type: 'warning' });
        },
      }
    );
  };

  
  if (record.transcript) {
    return (
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ flex: 5, display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <textarea style={{ flex: 5}} rows={redactedTranscript ? redactedTranscript.split(/\r\n|\r|\n/).length+1 : 1} defaultValue={redactedTranscript} onChange={handleTranscriptChange}/>
          <button onClick={handleSave}>{saveLabel}</button>
        </div>
      </div>
    ) 
  }
  else {
    return (
      <p> No transcript available </p>
    );
  };
};

const TagsBlock: React.FC = () => {
  const record = useRecordContext<Answer>();
  if (!record) return null;
  
  const notify = useNotify();
  const [update] = useUpdate();

  // init tags and checked
  // const [checkedAt, setCheckedAt] = useState<string>(record.checked_at || '');
  const [currentTags, setTags] = useState<string>(record.tags || '');
  
  
  const handleTagsChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setTags(e.target.value);
  };

  // Handle save button
  const handleSave = () => {
    update(
      'redact',
      { 
        id: record.id,
        data: {
          tags: currentTags,
        },
        previousData: record,
      },
      {
        onSuccess: () => notify('Tags updated', { type: 'info' }),
        onError: (error) => {
          console.error('Update error details:', error);
          notify('Error updating tags', { type: 'warning' });
        },
      }
    );
  };

  // create CheckBlock
  
  if (record.transcript) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

       <input defaultValue={record.tags} placeholder='Tags' onChange={handleTagsChange}/>
       <button onClick={handleSave}>Save tags</button><br/><br/>
      </div>
    ); 
  } else {
    return (
      <p> No transcript available </p>
    );
  }
};

